import { render } from "./formField.vue?vue&type=template&id=37c57a50&scoped=true&ts=true"
import script from "./formField.vue?vue&type=script&lang=ts"
export * from "./formField.vue?vue&type=script&lang=ts"

import "./formField.vue?vue&type=style&index=0&id=37c57a50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c57a50"]])

export default __exports__